<div class="container-fluid p-3">

  <!-- CRITICAL: Do not share exports externally. -->
  <div class="confidentiality-banner mb-3" role="alert">
    <mat-icon class="banner-icon">warning</mat-icon>
    <div>
      <div class="banner-title">Confidential: Internal Use Only</div>
      <div class="banner-body">
        Account exports contain the full internal database structure and client data. <strong>Never share exports with clients, customers, or any external or third-party parties under any circumstances.</strong> Export files are intended solely for internal SiteConnect engineering and support use. Sharing an export is a security and confidentiality breach.
      </div>
    </div>
  </div>

  <!-- Action Buttons -->
  <div class="d-flex mb-3">
    <button mat-raised-button color="primary" class="mr-2" (click)="onExport()">
      <mat-icon>cloud_download</mat-icon> Export Account Data
    </button>
    <button mat-raised-button color="accent" (click)="onImport()">
      <mat-icon>cloud_upload</mat-icon> Import Account Data
    </button>

    <!-- Hidden file input for ZIP upload. Uses a template ref (not a global id)
         so multiple tabs/instances would not collide. -->
    <input type="file" #importFileInput accept=".zip" style="display: none" (change)="onFileSelected($event)">
  </div>

  <!-- Operation History Table -->
  <div class="card">
    <div class="card-body">
      <h5 class="card-title mb-3">Operation History</h5>

      <div class="scroll-box">
        <table mat-table [dataSource]="history" class="w-100">

          <!-- Type Column -->
          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef>Type</th>
            <td mat-cell *matCellDef="let op">
              <mat-icon class="align-middle mr-1" style="font-size: 18px;">
                {{ op.type === 'export' ? 'cloud_download' : 'cloud_upload' }}
              </mat-icon>
              {{ op.type | titlecase }}
            </td>
          </ng-container>

          <!-- Status Column -->
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let op">
              <span class="badge"
                [ngClass]="{
                  'badge-secondary': op.status === 'queued',
                  'badge-primary': op.status === 'processing',
                  'badge-success': op.status === 'completed',
                  'badge-danger': op.status === 'failed'
                }">
                {{ op.status | titlecase }}
              </span>
            </td>
          </ng-container>

          <!-- Started At Column -->
          <ng-container matColumnDef="started_at">
            <th mat-header-cell *matHeaderCellDef>Started</th>
            <td mat-cell *matCellDef="let op">
              {{ op.started_at ? (op.started_at | date:'medium') : '-' }}
            </td>
          </ng-container>

          <!-- Completed At Column -->
          <ng-container matColumnDef="completed_at">
            <th mat-header-cell *matHeaderCellDef>Completed</th>
            <td mat-cell *matCellDef="let op">
              {{ op.completed_at ? (op.completed_at | date:'medium') : '-' }}
            </td>
          </ng-container>

          <!-- Records Column -->
          <ng-container matColumnDef="records">
            <th mat-header-cell *matHeaderCellDef>Records</th>
            <td mat-cell *matCellDef="let op">
              {{ getRecordCount(op) }}
            </td>
          </ng-container>

          <!-- Initiated By Column -->
          <ng-container matColumnDef="initiated_by">
            <th mat-header-cell *matHeaderCellDef>Initiated By</th>
            <td mat-cell *matCellDef="let op">
              {{ op.initiator?.contact_person || '-' }}
            </td>
          </ng-container>

          <!-- Actions Column -->
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let op">
              <button mat-icon-button
                *ngIf="op.type === 'export' && op.status === 'completed'"
                matTooltip="Download export file"
                (click)="onDownload(op)">
                <mat-icon>download</mat-icon>
              </button>
              <button mat-icon-button
                *ngIf="op.status === 'failed'"
                matTooltip="View error details"
                (click)="onViewError(op)">
                <mat-icon>error_outline</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <div *ngIf="history.length === 0 && !isLoading" class="text-center p-4 text-muted">
          No data transfer operations found for this account.
        </div>

        <mat-paginator
          [length]="totalHistory"
          [pageSize]="pageSize"
          [pageSizeOptions]="[10, 25, 50]"
          (page)="onPageChange($event)"
          showFirstLastButtons>
        </mat-paginator>
      </div>
    </div>
  </div>

</div>
